import React from "react"
import PrizeImage from '../../../images/xbox-series-x.png'
import PrizeMobileImage from '../../../images/xbox-series-x-282x431.png'
import stickercup from "../../../images/stickers_phonesmartPrize.png"

import "./PrizedrawSection.scss"

const PrizedrawSection = ({isCompleted}) => {
	return (
		<section className={`prize-draw-section ${isCompleted?"completed":""}`} id="enterprizedraw">

			<div className="row kids-prize-draw">
				<div className="col-12 col-md-7">
					{ (isCompleted)?
						<>
							<img src={stickercup} className="prize-sticker" alt="sticker cup"/>
							<div className="prize-content">
								<p>YOU COLLECTED 'EM ALL</p>
								<h2>NOW ENTER OUR PRIZE DRAW</h2>
								<p>Don't forget to ask your parent or a trusted grown up to enter you into our prize draw, for your chance to win an awesome Xbox X.</p>
							</div>
						</>
					:
						<div className="prize-content">
							<h2>COLLECT 'EM ALL TO ENTER OUR PRIZE DRAW</h2>
							<p>Complete all the episodes to collect all the stickers! Then ask your parent or guardian to enter you into the Prize Draw to win an awesome Xbox X.</p>
						</div>
					}
					
				</div>
				<div className="prize-col col-12 col-md-5">
					<div className="prize">
						<img src={PrizeImage} className="prize-img" alt="Playstation 5 console" />
						<img src={PrizeMobileImage} className="prize-img-m" alt="Playstation 5 console" />
					</div>
				</div>
			</div>
		</section>
	)
}

export default PrizedrawSection
